import React, {Fragment, useEffect, useState, useContext} from "react";
import {useHistory} from "react-router-dom";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import {useParams} from "react-router";
import {
    filterContactPlanFamilyTypeMembers,
    getAdultNames, getChildNameFromCommsPlan,
    getCommunicationsPlanDetails, itemName,
} from "root/DataFunctions/CommunicationsPlanDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {CommsPlanSectionTypes, FamilyTypes} from "root/DataFunctions/Constants";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";

import './AgreementPageBody.scss'
import FormItemText from "root/Wieldy/ApplicationModules/Child/Body/Agreements/FormComponents/FormItemText";
import ReactHookFormError from "root/Wieldy/ApplicationModules/Child/Body/Agreements/FormComponents/ReactHookFormError";
import FormItemTextArea from "root/Wieldy/ApplicationModules/Child/Body/Agreements/FormComponents/FormItemTextArea";
import FormItemToggle from "root/Wieldy/ApplicationModules/Child/Body/Agreements/FormComponents/FormItemToggle";
import HookFormAgreements from "root/Wieldy/ApplicationModules/Child/Body/Agreements/HookFormAgreements";
import RelationWarning from "root/Wieldy/ApplicationModules/Child/Body/Agreements/RelationWarning";

const AgreementPageBody = (props) => {

    const {child_uid, communications_plan_id} = useParams();

    const [commsPlanData, setCommsPlanData] = useState({isLoading: true, data: [], contact: []});

    const [buttonDisabled, setButtonDisabled] = useState(false);

    const history = useHistory();

    const sliderGroupStyle = {
        display: 'grid',
        gridTemplateColumns: '4fr 1fr',
        marginTop: '15px',
        fontSize: 'larger'
    }

    // const isMessager = watch('contact.is_messager');

    useEffect(() => {
        getData();
    }, [communications_plan_id]);

    // This is a custom section renderer, which is specific to CommsPlanSectionTypes.MESSAGING and contains the
    // fields which collectively define the messaging rules
    const renderMessagingSection = ({control, formErrors}) =>
    {
        return (
            <Fragment key='Messaging'>
                <div key='im' className='form-group' style={sliderGroupStyle}>
                    <label>Can Message</label>
                    <div style={{justifySelf: 'right'}}>
                        <FormToggle readOnly={false} control={control} name='contact.is_messager'/>
                    </div>
                    <ReactHookFormError formErrors={formErrors} name={'is_messager'}/>
                </div>

                {isMessager && <div key='il' className='form-group' style={sliderGroupStyle}>
                    <label>Via Letter Box</label>
                    <div style={{justifySelf: 'right'}}>
                        <FormToggle readOnly={false} control={control} name='contact.is_letterbox_required'/>
                    </div>
                    <ReactHookFormError formErrors={formErrors} name={'is_letterbox_required'}/>
                </div>}

                {isMessager && <div key='ib' className='form-group' style={sliderGroupStyle}>
                    <label>Reply Allowed</label>
                    <div style={{justifySelf: 'right'}}>
                        <FormToggle readOnly={false} control={control} name='contact.is_messaging_bidirectional'/>
                    </div>
                    <ReactHookFormError formErrors={formErrors} name={'is_messaging_bidirectional'}/>
                </div>}
            </Fragment>
        )
    }

    // This is a custom section renderer, which is specific to CommsPlanSectionTypes.LIFESTORY and contains the
    // fields which collectively define the rules for a life story contributor
    const renderLifeStorySection = ({control, formErrors}) =>
    {
        return (
            <Fragment key='lifeStory'>
                <div className='form-group' style={sliderGroupStyle}>
                    <label>Is Contributor</label>
                    <div style={{justifySelf: 'right'}}>
                        <FormToggle readOnly={false} control={control} name='contact.is_contributor'/>
                    </div>
                    <ReactHookFormError formErrors={formErrors} name={'is_contributor'}/>
                </div>
            </Fragment>
        )
    }

    // This is a custom section renderer, which is specific to CommsPlanSectionTypes.TEXT and renderd a text field with
    // a unique name which allows the server to determine what updates to make when saving
    const renderToggleSectionItem = ({heading, name, register, formErrors}) =>
    {
        return (
            <Fragment key={name}>
                <div className='form-group' style={{...sliderGroupStyle, fontSize: 'normal'}}>
                    <label style={{fontSize: 'normal'}}>{heading}</label>
                    <div style={{justifySelf: 'right'}}>
                        <FormToggle readOnly={false} control={control} name={'contact.' + name}/>
                    </div>
                    <ReactHookFormError formErrors={formErrors} name={name}/>
                </div>
            </Fragment>
        )
    }

    const renderSection = ({title, renderitems, control, register, formErrors}) =>
    {
        const fields = renderitems.map((item) =>
        {
            const sectionType = +(item.section_type);

            switch (sectionType)
            {
                case CommsPlanSectionTypes.TEXTAREA:
                    return <FormItemTextArea heading={item.heading}
                                             name={itemName(item.cpsp_id, item.cpr_id, sectionType)}
                                             formSectionName='contact' register={register} formErrors={formErrors}/>
                case CommsPlanSectionTypes.INPUT:
                    return <FormItemText heading={item.heading} name={itemName(item.cpsp_id, item.cpr_id, sectionType)}
                                         formSectionName='contact' register={register} formErrors={formErrors}/>
                case CommsPlanSectionTypes.TOGGLE:
                    return <FormItemToggle heading={item.heading}
                                           name={itemName(item.cpsp_id, item.cpr_id, sectionType)}
                                           formSectionName='contact' register={register} control={control}
                                           formErrors={formErrors}/>
                case CommsPlanSectionTypes.MESSAGING:
                    return renderMessagingSection({control: control, formErrors: formErrors});
                case CommsPlanSectionTypes.LIFESTORY:
                    return renderLifeStorySection({control: control, formErrors: formErrors});
                default:
                    return <div>Cannot render item</div>
            }
        });

        return (
            <AgreementSection title={title} key={title}>
                <div className='row'>
                    <div className='col-md-12'>
                        {fields}
                    </div>
                </div>
            </AgreementSection>
        )
    }

    const renderSections = (sections, control, register, formErrors) =>
    {
        return sections.map((section) =>
        {
            const params = {
                title: section.plan_section_title,
                renderitems: section.questions,
                control: control,
                register: register,
                formErrors: formErrors
            }
            return renderSection(params);
        })
    }

    const getData = () =>
    {
        getCommunicationsPlanDetails(child_uid, communications_plan_id, false, (response) =>
        {
            const data = getDataFromResponse(response)[0];

            setCommsPlanData({isLoading: false, data: data, contact: []})

        })
    }

    const onClickCancel = () =>
    {
        history.goBack();
    }

    const onSaveComplete = () =>
    {
        bootbox.alert({
            size: "small",
            message: "Changes have been saved.",
            callback: (result =>
            {
                history.goBack();
            })
        })
    }

    const formContent = () =>
    {
        const childName = getChildNameFromCommsPlan(commsPlanData.data)

        const birthRecs = filterContactPlanFamilyTypeMembers(FamilyTypes.BIRTH, commsPlanData.data.connections);

        const birthFamilyNames = getAdultNames(birthRecs);
        const adopterFamilyNames = getAdultNames(filterContactPlanFamilyTypeMembers(FamilyTypes.FOREVER, commsPlanData.data.connections));

        const childStyle = {color: '#81269c'};
        const adultStyle = {color: 'var(--s360-icon-blue)'};

        return (
            <div className='agreement-page-body'>

                <div style={{marginLeft: '10px'}}>
                    <h2>This defines the agreed communications to <span style={childStyle}>{childName}</span></h2>
                    <h3>Birth Parents: <span style={adultStyle}>{birthFamilyNames}</span></h3>
                    <h3>Adopters: <span style={adultStyle}>{adopterFamilyNames}</span></h3>
                </div>

                <RelationWarning connections={commsPlanData.data.connections}/>

                {commsPlanData.isLoading === false &&
                    <HookFormAgreements onClickCancel={onClickCancel} onSaveComplete={onSaveComplete}
                                        child_uid={child_uid} communications_plan_id={communications_plan_id}
                                        rows={commsPlanData.data.items}/>}
            </div>
        )
    }

    return (
        <Fragment>
            {commsPlanData.isLoading === true && <SpinnerDiv/>}
            {commsPlanData.isLoading === false && formContent()}
        </Fragment>
    );
};

export default AgreementPageBody;
